const INIT_STATE = {
    selectedReport: "performance",
    selectedReportType: "DAILY",
    selectedGraphType: "DAILY",
    selectedShiftType: "SHIFT_A",
    selectedShiftTypeGraph: "SHIFT_A",
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case "SELECTED_REPORT": {
            return {
                ...state,
                selectedReport: action.payload
            };
        }

        case "SELECTED_REPORTTYPE": {
            return {
                ...state,
                selectedReportType: action.payload
            };
        }

        case "SELECTED_GRAPHTYPE": {
            return {
                ...state,
                selectedGraphType: action.payload
            };
        }

        case "SELECTED_SHIFTTYPE": {
            return {
                ...state,
                selectedShiftType: action.payload
            };
        }
        case "SELECTED_SHIFTTYPE_GRAPH": {
            return {
                ...state,
                selectedShiftTypeGraph: action.payload
            };
        }


        default:
            return state;

    }
}